import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLock = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 14,
	height: 15,
	viewBox: "0 0 14 15",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		d: "M11.375 6H10.5V4.25C10.5 2.33594 8.91406 0.75 7 0.75C5.05859 0.75 3.5 2.33594 3.5 4.25V6H2.625C1.64062 6 0.875 6.79297 0.875 7.75V13C0.875 13.9844 1.64062 14.75 2.625 14.75H11.375C12.332 14.75 13.125 13.9844 13.125 13V7.75C13.125 6.79297 12.332 6 11.375 6ZM4.8125 4.25C4.8125 3.04688 5.76953 2.0625 7 2.0625C8.20312 2.0625 9.1875 3.04688 9.1875 4.25V6H4.8125V4.25ZM11.8125 13C11.8125 13.2461 11.5938 13.4375 11.375 13.4375H2.625C2.37891 13.4375 2.1875 13.2461 2.1875 13V7.75C2.1875 7.53125 2.37891 7.3125 2.625 7.3125H11.375C11.5938 7.3125 11.8125 7.53125 11.8125 7.75V13Z",
		fill: "#607D8B"
	})]
});
const ForwardRef = forwardRef(SvgLock);
export { ForwardRef as ReactComponent };
